export const FETCH_ACCOUNT_ACTIVITY = 'FETCH_ACCOUNT_ACTIVITY';
export const FETCH_ACCOUNT_ACTIVITY_SUCCESS = 'FETCH_ACCOUNT_ACTIVITY_SUCCESS';
export const FETCH_ACCOUNT_ACTIVITY_FAILURE = 'FETCH_ACCOUNT_ACTIVITY_FAILURE';
export const RESET_DATA_FOR_ACCOUNT_ACTIVITY_PAGE = 'RESET_DATA_FOR_ACCOUNT_ACTIVITY_PAGE';
